import React, {Component} from "react";
import "./pack-entrepreneurAB.css";
import PackEntrepreneurHeaderAB from './pack-entrepreneurAB-header'
import PackEntrepreneurContentAB from './pack-entrepreneurAB-content'
import PackEntrepreneurFooterAB from './pack-entrepreneurAB-footer'
import {packEntrepreneurData} from './pack-entrepreneurAB-Data';
import lpApp from "../../../app/lp_app";
import { packEntrepreneur } from "../../../redux/actions/checkout_operations";
import { connect } from 'react-redux';

class _PackEntrepreneurAB extends Component {
  componentDidMount() {
    this.props.entrepreneurPack(true);
  }
  
  render(){
    const {header,content,footer} = packEntrepreneurData[lpApp.contractMetaId]
    
    return(
      <main className="newPack-wrapper">
        <div className="corner-ribbon">recommandé</div>
        <PackEntrepreneurHeaderAB header={header} />
        <div className="details">
          {content && content.length && content.map((option) => {
            return <PackEntrepreneurContentAB {...option}/>
          }).reduce((prev, curr) => [prev,<div className="separator">+</div>, curr])}
        </div>
        <PackEntrepreneurFooterAB  selectPack={this.props.selectPack} index={this.props.index} footer={footer} />
      </main>
    )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  entrepreneurPack: (val) => {
    dispatch(packEntrepreneur(val));
  },
});


const PackEntrepreneurAB = connect(null, mapDispatchToProps)(_PackEntrepreneurAB);

export default PackEntrepreneurAB;


// WEBPACK FOOTER //
// ./src/components/buy/upsell/pack-entrepreneurAB.js